module.exports = __webpack_public_path__ + "img/Accessibility.bdbc656f.png";